import React from "react";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Popup = ({
  message,
  onClose,
  navigateTo,
  navigateState,
  showchildren = false,
  children,
}) => {
  const navigate = useNavigate();

  const handleOk = () => {
    if (navigateTo) {
      navigate(navigateTo, { state: navigateState });
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
      <div className="relative w-full max-w-md rounded-xl bg-white shadow-2xl p-6 animate-fadeIn">

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-[#0A2A4F]"
        >
          <X size={22} />
        </button>

        {/* Title */}
        <h3 className="text-lg font-semibold text-[#0A2A4F] text-center">
          Notification
        </h3>

        {/* Message */}
        {message && (
          <p className="mt-4 text-center text-gray-700 leading-relaxed">
            {message}
          </p>
        )}

        {/* Optional Children */}
        {showchildren && (
          <div className="mt-4 flex justify-center">{children}</div>
        )}

        {/* OK Button */}
        <div className="mt-6 flex justify-center">
          <button
            onClick={handleOk}
            className="px-6 py-2 rounded-full bg-[#0A2A4F] text-white hover:bg-[#08305e] transition"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
